import { UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import type { AddressLinks } from 'shared/types/AddressLinks';
import { isLastListItem } from 'shared/utils/array/isLastListItem';
import { stopPropagation } from 'shared/utils/event/stopPropagation';

import { Link } from '../InteractiveTypography';

type CardAddressBlockProps = {
  address: Array<AddressLinks>;
  track(): void;
};

export const CardAddressBlock: FC<CardAddressBlockProps> = props => {
  const { address, track } = props;

  return (
    <div>
      {address.map((addressPart, index, addressParts) => {
        return (
          <UIText2 color="gray60_100" display="inline" key={addressPart.id}>
            <Link
              behaviour="hover_gray_to_primary"
              display="inline"
              href={addressPart.offersUrl}
              track={track}
              onClick={stopPropagation}
            >
              {`${addressPart.title}${isLastListItem(addressParts, index) ? '' : ',\u0020'}`}
            </Link>
          </UIText2>
        );
      })}
    </div>
  );
};
